import { Field } from 'formik'
import classnames from 'classnames'
import { ButtonDrawer, InputField } from '~/components'
import { useTranslation } from 'react-i18next'
import * as styles from './index.module.css'

const cx = classnames.bind(styles)

export default function EditField({ fields, title, onClose }) {
  const { t } = useTranslation()

  return (
    <div className={styles.wrapper}>
        <div className={styles.title}>{title}</div>
        {fields?.map(field => {
          return <Field key={field.id} name={field.id} placeholder={field.title} tabIndex="0" maxLength="30" component={InputField} />
        })
        }
        <ButtonDrawer buttons={[{ func: onClose, title: t('button-save')}]} />
    </div>
  )
}

